 
import SEO from "../../components/common/seo/SEO";
import CourseLandingPage from "../../components/Courses/CourseLandingPage/CourseLandingPage";
import creoToolkitCourse from "../../data/cad_section/creoToolkitCourse";

function CreoToolKitPage() {
    return (
        <>
           <SEO
        title="Creo Toolkit Customization & Automation Training | Creo Toolkit Course | FeesWorth"

        description="Learn PTC Creo Toolkit customization and automation with practical projects. Master Creo Toolkit API, CAD automation, custom applications, feature automation, and Creo customization development with expert training at FeesWorth."

        keywords="Creo Toolkit Training, Creo Toolkit Course, Creo Customization Training, Creo Automation Training, Creo Toolkit API, PTC Creo Toolkit, Creo C++ Training, Creo API Training, Creo Automation Course, Creo Customization Course"

        canonical="https://feesworth.com/creo-toolkit-customization-training"
      />
            <CourseLandingPage course={creoToolkitCourse} />
        </>
    );
}

export default CreoToolKitPage; 